import { render, staticRenderFns } from "./SystemManagement.vue?vue&type=template&id=c3d276a0&scoped=true&"
import script from "./SystemManagement.vue?vue&type=script&lang=js&"
export * from "./SystemManagement.vue?vue&type=script&lang=js&"
import style0 from "./SystemManagement.vue?vue&type=style&index=0&id=c3d276a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d276a0",
  null
  
)

export default component.exports